import { render, staticRenderFns } from "./volRequire.vue?vue&type=template&id=791c77bf"
import script from "./volRequire.vue?vue&type=script&lang=js"
export * from "./volRequire.vue?vue&type=script&lang=js"
import style0 from "./volRequire.vue?vue&type=style&index=0&id=791c77bf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports